import { Stack } from '@mui/material';
import { RadialBarChart, PolarAngleAxis, RadialBar } from 'recharts';

export const DATA_KEY = 'value';
export const CIRCLE_D = 80;
export const CIRCLE_R = CIRCLE_D / 2;

type RetailerNetworkMonthlyGoalCircularProgressProps = {
  value: number;
  color: string;
};

export const RetailerNetworkMonthlyGoalCircularProgress = ({
  value,
  color,
}: RetailerNetworkMonthlyGoalCircularProgressProps) => {
  return (
    <Stack alignItems='center' sx={{ textAlign: 'center', width: '100px' }}>
      <RadialBarChart
        width={CIRCLE_D}
        height={CIRCLE_D}
        innerRadius='100%'
        barSize={6}
        data={[{ fill: color, [DATA_KEY]: value }]}
        endAngle={-270}
        startAngle={90}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      >
        <PolarAngleAxis domain={[0, 100]} type='number' cx={CIRCLE_R} cy={CIRCLE_R} tick={false} />
        <RadialBar background dataKey={DATA_KEY} cornerRadius={15 / 2} />
      </RadialBarChart>
    </Stack>
  );
};
